
import { IonCard, IonCardHeader, IonCardSubtitle, IonCardTitle } from '@ionic/react'
import DataScienceProjects from './DataScienceProjects'
import WebAppDevProjects from './WebAppDevProjects'

function NotableProjects(){
  return(
    <IonCard className = "ion-padding">
      <IonCardHeader>
        <IonCardTitle className="ion-text-center">Selected Projects</IonCardTitle>
        <IonCardSubtitle className="ion-text-center">Click an item to learn more</IonCardSubtitle>
      </IonCardHeader>

      <IonCardSubtitle className = "ion-padding">Data Science</IonCardSubtitle>
      <DataScienceProjects />

 

      <IonCardSubtitle className = "ion-padding">Web and App Development</IonCardSubtitle>
      <WebAppDevProjects />
    </IonCard>
  )
}

export default NotableProjects